import { DownArrowIcon } from "@/components/data-display/Icon";
import { AnimatePresence, motion } from "framer-motion";

function FaqCard({ faq, selectedQuestionId, setQuestionId }) {
  const isOpen = selectedQuestionId === faq.id;

  return (
    <div className="flex flex-col">
      <div
        role="button"
        onClick={() => setQuestionId(faq.id)}
        className="flex flex-row justify-between items-start"
      >
        <p className="text-[1.25rem] max-w-[90%] font-bold">{faq.question}</p>
        <DownArrowIcon className="mt-[0.25rem]" />
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.p
            variants={{
              open: {
                height: "auto",
                overflow: "hidden",
                marginTop: "32px",
              },
              closed: {
                height: 0,
                overflow: "hidden",
                marginTop: 0,
              },
            }}
            initial="closed"
            animate="open"
            exit="closed"
            transition={{ delay: 0.1, duration: 0.4 }}
          >
            {faq.answer}
          </motion.p>
        )}
      </AnimatePresence>

      <div className="border border-[#05042614] my-[2rem] lg:my-[2.5rem]" />
    </div>
  );
}

export default FaqCard;
